export default __webpack_public_path__ + "static/media/s3_female.1c9d953d.wav";